export default "__VITE_PUBLIC_ASSET__97672bb4__"